import { render, staticRenderFns } from "./ReturnPackageView.vue?vue&type=template&id=fb061a66&"
import script from "./ReturnPackageView.vue?vue&type=script&lang=ts&"
export * from "./ReturnPackageView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReturnPackageView.vue"
export default component.exports